import { cn } from "@ui/lib/utils";

interface SoundBoardButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  fixedSize?: boolean;
}

export const SoundBoardButton = ({
  className,
  children,
  fixedSize = true,
  disabled,
  ...props
}: SoundBoardButtonProps) => {
  return (
    <button
      className={cn(
        "button-soundboard relative flex w-full flex-col items-center justify-center gap-10 rounded-md p-4 px-8 transition-all duration-200 ease-in-out",
        fixedSize && "aspect-1x1",
        disabled && "opacity-70",
        className,
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};
